import { MapPin } from 'lucide-react';
import { clsx } from 'clsx';

export interface LocationOption {
  id: string;
  name: string;
  count?: number;
}

export interface LocationFilterProps {
  options: LocationOption[];
  selected: string;
  onChange: (id: string) => void;
  className?: string;
}

export function LocationFilter({ options, selected, onChange, className }: LocationFilterProps) {
  return (
    <div className={clsx('flex items-center gap-1.5 text-xs text-text-secondary', className)}>
      <MapPin size={13} className="text-text-muted flex-shrink-0" />
      <span className="hidden sm:inline text-[11px] text-text-muted font-medium">Sede:</span>
      <select
        value={selected}
        onChange={(e) => onChange(e.target.value)}
        aria-label="Filtrar por sede"
        className="bg-surface-secondary border border-border text-text-primary rounded-lg px-2.5 py-1.5 text-xs font-medium focus:outline-none focus:ring-1 focus:ring-brand-primary cursor-pointer max-w-[160px] truncate transition-colors"
      >
        <option value="all" className="bg-surface text-text-primary font-semibold">
          Todas las sedes
        </option>
        {options.map((opt) => (
          <option key={opt.id} value={opt.id} className="bg-surface text-text-primary font-medium">
            {opt.name} {opt.count !== undefined ? `(${opt.count})` : ''}
          </option>
        ))}
      </select>
    </div>
  );
}
